import currencyFormatter from 'currency-formatter';
import dateFormat from 'dateformat';
import _ from 'lodash';
import moment from 'moment';
import { parseFullName } from 'parse-full-name';
import base64 from 'base-64';

export function friendlyCreditCardMask(creditCardMask) {
  if (_.isEmpty(creditCardMask)) {
    return '';
  }
  return creditCardMask.substr(creditCardMask.length - 4);
}
export function parseAmount(amount) {
  return currencyFormatter.format(amount / 100, { code: 'AUD' });
}

export function formatAmount(amount) {
  return currencyFormatter.format(amount, { code: 'AUD' });
}
export function parseFloatCurrency(amount) {
  if (typeof amount !== 'string') {
    return amount;
  }
  return parseFloat(amount.replace(',', '').replace('$', ''));
}

export function unformatAmountDollarSign(amount) {
  if (amount === undefined) {
    return '';
  }
  if (typeof amount !== 'string') {
    return amount;
  }
  return amount.replace('$', '');
}

export function simpleDateNoTime(dateString) {
  const date = new Date(dateString);
  const momentDate = moment(date);
  return momentDate.format('D MMM YYYY');
}
export function parseTotal(payment, relevantPaymentCollections) {
  return currencyFormatter.format(
    (payment.amount * relevantPaymentCollections.length) / 100,
    { code: 'AUD' },
  );
}

export function parsePending(payment, relevantPaymentCollections) {
  return relevantPaymentCollections.filter((t) => t.status === 'pending')
    .length;
}

export function parseCollected(payment, relevantPaymentCollections) {
  return relevantPaymentCollections.filter((t) => t.status === 'collected')
    .length;
}

export function friendlyDate(dateString = null) {
  const date = dateString === null ? new Date() : new Date(dateString);
  const momentDate = moment(date);
  return momentDate.format('dddd, D MMMM YYYY');
}

export function simpleFriendlyDate(dateString = null) {
  const date = dateString === null ? new Date() : new Date(dateString);
  const momentDate = moment(date);
  return momentDate.format('ddd, D MMM YY');
}

export function friendlyTime(dateString = null) {
  // console.log(dateString);
  const date = dateString === null ? new Date() : new Date(dateString);
  const momentDate = moment(date);
  return momentDate.format('h:mm a');
}

export function friendlyDateTime(dateString = null) {
  // console.log(dateString);
  const date = dateString === null ? new Date() : new Date(dateString);
  const momentDate = moment(date);
  return momentDate.format('h:mm a - D MMM');
}

export function combinedTime(dateString, timeString) {
  const date = dateString === null ? new Date() : new Date(dateString);
  const momentDate = moment(date);

  const time = timeString === null ? new Date() : new Date(timeString);
  const momentTime = moment(time);

  const combinedString = `${momentDate.format(
    'ddd MMM D YYYY',
  )} ${momentTime.format('hh:mm:ss a')}`;

  const combinedDate = new Date(combinedString);
  const momentCombinedDate = moment(combinedDate);

  // console.log(date);
  // console.log(time);
  // console.log(combinedString);
  // console.log(combinedDate);
  return momentCombinedDate.format('ddd MMM D YYYY hh:mm:ss a');
}

export function getTimeRange(sinceTime, untilTime = undefined): any {
  const sinceDate = sinceTime === undefined ? new Date() : new Date(sinceTime);
  const untilDate = untilTime === undefined ? sinceDate : new Date(untilTime);
  const sinceDateStart = moment(sinceDate).startOf('day');
  const untilDateEnd = moment(untilDate).endOf('day');
  const sinceTimeParsed = convertToUtc(sinceDateStart.format());
  const untilTimeParsed = convertToUtc(untilDateEnd.format());
  return { sinceTimeParsed, untilTimeParsed };
}

export function getTimeFromDateTime(dateString) {
  const date = new Date(dateString);
  const momentDate = moment(date);
  return momentDate.format('h:mm a');
}

export function simpleDate(dateString) {
  const date = new Date(dateString);
  const momentDate = moment(date);
  return momentDate.format('D MMM YYYY - h:mm a');
}

export function simpleDateTwo(dateString) {
  const date = new Date(dateString);
  const momentDate = moment(date);
  return momentDate.format('D MMM YYYY');
}
export function simpleDateThree(dateString) {
  const date = new Date(dateString);
  const momentDate = moment(date);
  return momentDate.format('D MMM');
}

export function superSimpleDate(dateString = null) {
  const date = dateString === null ? new Date() : new Date(dateString);
  const momentDate = moment(date);
  // return momentDate.format('D MMM YY');

  return momentDate.calendar(null, {
    sameDay: '[Today]',
    nextDay: '[Tomorrow]',
    nextWeek: 'D MMM YY',
    lastDay: '[Yesterday]',
    lastWeek: 'D MMM YY',
    sameElse: 'D MMM YY',
  });
}

export function convertToUtc(dateString = null) {
  const date = dateString === null ? new Date() : new Date(dateString);
  const momentDate = moment(date, 'ddd MMM DD YYYY HH:mm:ss GMT+1000 (AEST)');
  const dateInUTC = momentDate.utc();
  return dateInUTC.toString();
}

export function convertToUtcDate(dateString = null) {
  const date = dateString === null ? new Date() : new Date(dateString);
  const momentDate = moment(date);

  const dateInUTC = momentDate.utc().format('YYYY-MM-DD z');
  return dateInUTC.toString();
}

export function roundMinutes(date) {
  date.setHours(date.getHours() + Math.round(date.getMinutes() / 60));
  date.setMinutes(0);
  return date;
}

export function formatApiError(errors) {
  if (!_.isEmpty(errors)) {
    let returnError = '';
    _.forIn(errors, (value, key) => {
      if (!_.isEmpty(value) && !_.isEmpty(key)) {
        const objectName = JSON.stringify(key)
          .replace(/[":0-9_-]/g, ' ')
          .trim();

        let errorMessage;
        if (value.constructor === Array) {
          errorMessage = JSON.stringify(value.join(', '))
            .replace(/[":0-9_-]/g, ' ')
            .trim();
        } else {
          errorMessage = value.replace(/[":0-9_-]/g, ' ').trim();
        }
        if (!_.isEmpty(objectName)) {
          returnError += `${objectName}: ${errorMessage} `;
        } else {
          returnError += `${errorMessage} `;
        }
      } else {
        returnError = 'Unknown error';
      }
    });
    return returnError;
  }
  return '';
}

export function formatAssemblyCreditCardError(errorMessage) {
  if (!_.isEmpty(errorMessage)) {
    if (errorMessage.includes('process the purchase transaction')) {
      return 'We were unable to process your payment. Please check your card details, try another card or call your card provider.';
    }

    if (
      errorMessage.includes(
        'Processing taking longer than usual on our payment gateway',
      )
    ) {
      return 'Processing taking longer than usual from our payment gateway. Your transaction will most likely process successfully. Once it has processed, we will update the status of your match payment automatically.';
    }

    if (
      errorMessage.includes(
        'Please check that you have entered your credit card details correctly',
      )
    ) {
      return 'Card details supplied were invalid, please add a new card and check that you have entered your credit card details correctly.';
    }
    return errorMessage
      .replace('base', '')
      .replace(/[[\]":0-9_-]/g, '')
      .trim();
  }
  return '';
}

export function formatExpiry(expiryDate, strSeparator, year) {
  let expiry = expiryDate;
  let separator = strSeparator;
  let fourDigitYear = year;

  if (separator === undefined || separator === null) {
    separator = ' / ';
  }
  if (fourDigitYear === undefined || fourDigitYear === null) {
    fourDigitYear = false;
  }
  // Separator must be a string
  if (typeof separator !== 'string') {
    separator = ' / ';
  }

  // Expiry must exist
  if (!expiry) {
    expiry = '';
  }
  const digitSearch = /\D/g;
  const expiryMaxLength = 2 + (fourDigitYear ? 4 : 2);
  // Replace non-numeric characters
  expiry = expiry.replace(digitSearch, '');
  // Only add the separator after the 3rd digit. Adding on the second can prevent backspaces in some cases (e.g. when
  // expiry is connected to a React state).
  if (expiry.length === 6) {
    expiry = expiry.slice(0, 2) + separator + expiry.slice(4, expiryMaxLength + 2);
  } else if (expiry.length >= 3) {
    expiry = expiry.slice(0, 2) + separator + expiry.slice(2, expiryMaxLength);
  }
  return expiry;
}

export function parseCardInput(cardName, cardNumber, expiry, cvc) {
  const cleanedCardName = cardName.replace('  ', ' ').trim();
  const cardNameAttrs = parseFullName(cleanedCardName);
  let formattedName;
  const firstName = cardNameAttrs.first;
  let lastName = cardNameAttrs.last;

  if (_.startsWith(lastName, 'On')) {
    if (_.isEmpty(firstName) || _.startsWith(firstName, 'On')) {
      lastName = `O${lastName}`;
    } else {
      lastName = `${firstName}`;
    }
  }

  if (_.isEmpty(firstName)) {
    formattedName = `${lastName} ${lastName}`;
  } else {
    formattedName = `${firstName} ${lastName}`;
  }

  if (formattedName.trim().split(' ').length === 1) {
    formattedName = `${formattedName.trim()} ${formattedName.trim()}`;
  }
  formattedName = formattedName.trim();

  // NUMBER
  const parsedCardNumber = cardNumber.replace(/\D/g, '');

  // EXPIRY
  const parsedExpiry = formatExpiry(expiry);
  const expiryMonth = parsedExpiry.split('/')[0].trim();
  const expiryYear = parsedExpiry.split('/')[1].trim();
  const cardDate = new Date(`${expiryMonth}/01/20${expiryYear}`);
  const parsedMonth = dateFormat(cardDate, 'mm');
  const parsedYear = dateFormat(cardDate, 'yyyy');

  // CVC
  const parsedCvc = cvc.replace(/\D/g, '');
  const cardResponse = {
    fullName: formattedName,
    number: parsedCardNumber,
    expiryMonth: parsedMonth,
    expiryYear: parsedYear,
    cvc: parsedCvc,
  };

  return cardResponse;
}

export function friendlyErrorMessage(message) {
  switch (message) {
    case 'Username/client id combination not found.':
      return 'We couldn\'t find that email. Please try again.';
    case 'User does not exist.':
      return 'We couldn\'t find that email. Please try again.';
    default:
      return message;
  }
}

export function parseStatus(inputStatus: string): string {
  let parsedText = '';
  if (inputStatus === 'pending') {
    parsedText = 'Pending';
  }
  if (inputStatus === 'paid') {
    parsedText = 'Teammo';
  }
  if (inputStatus === 'active') {
    parsedText = 'Active';
  }
  if (inputStatus === 'cancelled') {
    parsedText = 'Cancelled';
  }
  if (inputStatus === 'collected') {
    parsedText = 'Collected';
  }
  if (inputStatus === 'confirmed') {
    parsedText = 'Confirmed';
  }
  if (inputStatus === 'paid-transferred') {
    parsedText = 'Teammo';
  }
  if (inputStatus === 'paid-refunded') {
    parsedText = 'Refunded';
  }
  if (inputStatus === 'no-show') {
    parsedText = 'No-show';
  }
  if (inputStatus === 'walkover') {
    parsedText = 'Forfeit';
  }
  if (inputStatus === 'cancelled') {
    parsedText = 'Cancelled';
  }
  if (inputStatus === 'paid-cash') {
    parsedText = 'Cash';
  }
  if (inputStatus === 'paid-eftpos') {
    parsedText = 'Eftpos';
  }
  if (inputStatus === 'paid-prepaid') {
    parsedText = 'Pre-paid';
  }
  if (inputStatus === 'transfer-required') {
    parsedText = 'Transfer Pending';
  }
  if (inputStatus === 'transferred') {
    parsedText = 'Transferred';
  }
  if (inputStatus === 'refunded') {
    parsedText = 'Refunded';
  }
  if (inputStatus === 'owing') {
    parsedText = 'Owing';
  }
  if (inputStatus === 'up-to-date') {
    parsedText = 'Up-to-date';
  }
  if (inputStatus === 'overdue') {
    parsedText = 'Overdue';
  }
  return parsedText;
}

export function parsePaymentStatusText(
  status = 'pending',
  otherTeamStatus = 'pending',
  defaultText = 'Unpaid',
  noActive = false,
  dueDate = null,
) {
  let parsedText = defaultText;
  if (status === 'paid') {
    parsedText = 'Teammo';
  }
  if (status === 'active' && !noActive) {
    parsedText = 'Active';
  }
  if (status === 'cancelled') {
    parsedText = 'Cancelled';
  }
  if (status === 'inactive') {
    parsedText = 'Inactive';
  }
  if (status === 'collected') {
    parsedText = 'Paid';
  }
  if (status === 'paid-transferred') {
    parsedText = 'Teammo';
  }
  if (status === 'paid-refunded') {
    parsedText = 'Refunded';
  }
  if (status === 'no-show' || otherTeamStatus === 'no-show') {
    parsedText = 'No-show';
  }
  if (status === 'walkover' || otherTeamStatus === 'walkover') {
    parsedText = 'Forfeit';
  }
  if (status === 'cancelled') {
    parsedText = 'Cancelled';
  }
  if (status === 'paid-cash') {
    parsedText = 'Paid (Cash)';
  }
  if (status === 'collected-bank-transfer') {
    parsedText = 'Paid (Bank)';
  }
  if (status === 'collected-other') {
    parsedText = 'Paid (Other)';
  }
  if (status === 'collected-cash') {
    parsedText = 'Paid (Cash)';
  }
  if (status === 'collected-eftpos') {
    parsedText = 'Paid (Eftpos)';
  }
  if (status === 'paid-bank-transfer') {
    parsedText = 'Paid (Bank)';
  }
  if (status === 'paid-other') {
    parsedText = 'Paid (Other)';
  }
  if (status === 'paid-eftpos') {
    parsedText = 'Paid (Eftpos)';
  }
  if (status === 'paid-prepaid') {
    parsedText = 'Paid (Pre-paid)';
  }
  if (status === 'transfer-required') {
    parsedText = 'Transfer Pending';
  }
  if (status === 'transferred') {
    parsedText = 'Transferred';
  }
  if (status === 'refunded') {
    parsedText = 'Refunded';
  }
  if (status === 'owing') {
    parsedText = 'Owing';
  }
  if (status === 'up-to-date') {
    parsedText = 'Up-to-date';
  }
  if (status === 'overdue') {
    parsedText = 'Overdue';
  }
  if (status === 'pending' && dueDate !== null && new Date(dueDate) < new Date()) {
    parsedText = 'Overdue';
  }

  return parsedText;
}

export function parseBadgeColor(paymentText) {
  let color = 'grey';
  let checked = false;
  let processing = false;
  if (paymentText === 'pending') {
    color = 'purple';
  }
  if (paymentText === 'Overdue') {
    color = 'red';
  }
  if (paymentText === 'Cancelled') {
    color = 'black';
  }
  if (paymentText === 'Inactive') {
    color = 'red';
  }
  if (paymentText === 'Walkover') {
    color = 'black';
  }
  if (paymentText === 'Forfeit') {
    color = 'black';
  }
  if (paymentText === 'No-show') {
    color = 'black';
  }
  if (paymentText === 'Up-to-date') {
    color = 'green';
  }
  if (paymentText === 'Active') {
    color = 'green';
  }
  if (paymentText === 'Collecting' || paymentText === 'In Progress') {
    color = 'purple';
    processing = true;
  }
  if (paymentText === 'Collected') {
    color = 'green';
    checked = true;
  }
  if (paymentText === 'Owing') {
    color = 'medium-grey';
  }
  if (paymentText === 'Setting Up') {
    color = 'medium-grey';
  }
  if (paymentText === 'Overdue') {
    color = 'red';
  }
  if (paymentText === 'Transferred') {
    color = 'dark-purple';
  }
  if (paymentText === 'Transfer Pending') {
    color = 'dark-purple';
  }
  if (
    paymentText === 'Paid'
      || paymentText === 'Paid Teammo'
      || paymentText === 'Teammo'
  ) {
    color = 'purple';
    checked = true;
  }
  if (paymentText === 'Paid Cash' || paymentText === 'Paid (Cash)') {
    color = 'orange';
    checked = true;
  }
  if (paymentText === 'Paid Bank Transfer' || paymentText === 'Paid (Bank)') {
    color = 'blue';
    checked = true;
  }
  if (paymentText === 'Paid Other' || paymentText === 'Paid (Other)') {
    color = 'yellow';
    checked = true;
  }
  if (paymentText === 'Paid Eftpos' || paymentText === 'Paid (Eftpos)') {
    color = 'blue';
    checked = true;
  }
  if (paymentText === 'Paid Pre-paid' || paymentText === 'Paid (Pre-paid)') {
    color = 'yellow';
    checked = true;
  }
  return [color, checked, processing];
}

export function parseAmountColor(paymentText) {
  let color = 'grey';
  let checked = false;
  let processing = false;
  if (paymentText === 'pending') {
    color = 'grey';
  }
  if (paymentText === 'Overdue') {
    color = 'red';
  }
  if (paymentText === 'Cancelled') {
    color = 'black';
  }
  if (paymentText === 'Inactive') {
    color = 'red';
  }
  if (paymentText === 'Walkover') {
    color = 'black';
  }
  if (paymentText === 'Forfeit') {
    color = 'black';
  }
  if (paymentText === 'No-show') {
    color = 'black';
  }
  if (paymentText === 'Up-to-date') {
    color = 'green';
  }
  if (paymentText === 'Active') {
    color = 'green';
  }
  if (paymentText === 'Collecting' || paymentText === 'In Progress') {
    color = 'purple';
    processing = true;
  }
  if (paymentText === 'Collected') {
    color = 'green';
    checked = true;
  }
  if (paymentText === 'Owing') {
    color = 'medium-grey';
  }
  if (paymentText === 'Setting Up') {
    color = 'medium-grey';
  }
  if (paymentText === 'Overdue') {
    color = 'red';
  }
  if (paymentText === 'Transferred') {
    color = 'dark-purple';
  }
  if (paymentText === 'Transfer Pending') {
    color = 'dark-purple';
  }
  if (
    paymentText === 'Paid'
    || paymentText === 'Paid Teammo'
    || paymentText === 'Teammo'
  ) {
    color = 'green';
    checked = true;
  }
  if (paymentText === 'Paid Cash' || paymentText === 'Paid (Cash)') {
    color = 'green';
    checked = true;
  }
  if (paymentText === 'Paid Bank Transfer' || paymentText === 'Paid (Bank)') {
    color = 'green';
    checked = true;
  }
  if (paymentText === 'Paid Other' || paymentText === 'Paid (Other)') {
    color = 'green';
    checked = true;
  }
  if (paymentText === 'Paid Eftpos' || paymentText === 'Paid (Eftpos)') {
    color = 'green';
    checked = true;
  }
  if (paymentText === 'Paid Pre-paid' || paymentText === 'Paid (Pre-paid)') {
    color = 'green';
    checked = true;
  }
  return [color, checked, processing];
}

export function parseApiErrors(errors) {
  const errString = _.map(
    errors,
    (value, key) => `${value.title}: ${value.detail}`,
  ).join(', ');
  return errString;
}

export function utf8ToB64(str) {
  return base64.encode(unescape(encodeURIComponent(str)));
}

export function b64ToUtf8(str) {
  return decodeURIComponent(escape(base64.decode(str)));
}
